import { Route, Routes, useLocation } from "react-router-dom";

import Address from "./pages/Address";
import Age from "./pages/Age";
import { ContextProvider } from "./contexts/data";
import Email from "./pages/Email";
import Footer from "./components/Footer";
import GuildConfirmation from "./pages/GuildConfirm";
import Head from "./components/Head";
import HiddenInput from "./components/HiddenInput";
import HomeAmount from "./pages/HomeAmount";
import ManualAddress from "./pages/ManualAddress";
import NoticeAtCollection from "./pages/NoticeAtCollection";
import MortgageBalance from "./pages/MortgageBalance";
import PhoneNumber from "./pages/PhoneNumber";
import Result from "./pages/Result";
import TestResult from "./pages/TestResult";
import UserName from "./pages/UserName";
import Verification from "./pages/Verification";
import ZipCode from "./pages/ZipCode";
import { handleQueryStrings } from "./util/querystring";
import styled from "styled-components";
import { useEffect } from "react";

const {
  ppcid,
  cid,
  tsid,
  gclid,
  offer,
  fullQueryString,
  phoneNumber,
  changeHeadline,
  isPurchase,
  isCobrand
} = handleQueryStrings();

function App() {
  const location = useLocation();

  useEffect(() => {
    if (window.innerWidth < 500) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [location]);

  return (
    <ContextProvider ppcid={ppcid} cid={cid} gclid={gclid} tsid={tsid} fullQueryString={fullQueryString}>
      <form style={{ display: "none" }}></form>
      <OutWrapper>
        <Head phoneNumber={phoneNumber} isCobrand={isCobrand} />
        <Wrapper>
          <Routes>
            <Route
              path="/"
              element={
                <Age
                  changeHeadline={changeHeadline} isPurchase={isPurchase}
                />
              }
            />
            <Route path="/address" element={<Address />} />
            <Route path="/email" element={<Email />} />
            <Route path="/guild-confirmation" element={<GuildConfirmation />} />
            <Route path="/verification" element={<Verification />} />
            <Route path="/home-value" element={<HomeAmount />} />
            <Route path="/manual-address" element={<ManualAddress />} />
            <Route
              path="/mortgage-balance"
              element={<MortgageBalance />}
            />
            <Route
              path="/phone-number"
              element={<PhoneNumber />}
            />
            <Route path="/result" element={<Result />} />
            <Route path="/test-result" element={<TestResult />} />
            <Route
              path="/zip-code"
              element={<ZipCode offer={offer} />}
            />
            <Route path="/user-name" element={<UserName />} />
            <Route path="/notice-at-collection" element={<NoticeAtCollection />} />
            <Route
              path="*"
              element={
                <Age
                  changeHeadline={changeHeadline} isPurchase={isPurchase}
                />
              }
            />
          </Routes>
          <HiddenInput isShow={location.pathname === "/phone-number" || location.pathname === '/verification'} />
        </Wrapper>
        <Footer
          hideBBB={
            location.pathname === "/result"
          }
        />
      </OutWrapper>
    </ContextProvider>
  );
}

const OutWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Wrapper = styled.div`
  width: 100%;
  flex: 1;
  margin-top: 40px;
  display: flex;
  justify-content: "center";
  align-items: center;
  flex-direction: column;

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .fade-enter {
    opacity: 0;
    transform: translate(0, 100%);
    z-index: 1;
  }
  .fade-enter.fade-enter-active {
    opacity: 1;
    transform: translate(0, 0);
    transition: opacity 1s ease-out, transform 1s ease;
  }
  .fade-exit {
    opacity: 1;
    transform: translate(0, 0);
  }
  .fade-exit.fade-exit-active {
    opacity: 0;
    transform: translate(0, 100%);
    transition: opacity 1s ease-out, transform 1s ease;
  }
`;

export default App;
